<template>
    <v-card>
        <v-card-title
            class="font-weight-bold darkgrey--text"
            style="word-break: break-word !important"
        >
            {{ $attrs.detail.intrepretation_id ? "Ubah" : "Tambah" }} Jenis
            Interpretasi
        </v-card-title>
        <v-card flat class="mx-5 my-5">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        style="font-size: 14px"
                        class="font-weight-500 black60--text pb-2"
                    >
                        Judul
                    </v-list-item-title>
                    <v-select
                        placeholder="Judul"
                        :items="list_potential"
                        item-text="name"
                        item-value="id"
                        v-model="data.title"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content>
                    <v-row style="align-items: center">
                        <v-col cols="4" class="d-flex justify-center">
                            <a href="javascript:;">
                                <img
                                    :src="
                                        url
                                            ? url
                                            : data.image && data.image != ''
                                              ? data.image
                                              : require('@/assets/img/unavailable.png')
                                    "
                                    :key="keyimg"
                                />
                            </a>
                        </v-col>

                        <v-col cols="6">
                            <v-btn
                                @click="$refs.uploader.click()"
                                depressed
                                class="font-weight-bold blew--text"
                            >
                                Upload Foto
                            </v-btn>

                            <input
                                id="photo_tema_skala"
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />

                            <div
                                class="mt-3 grey--text"
                                style="font-size: 13px"
                            >
                                Rasio thumbnail Icon 1:1 (HD)
                            </div>
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        style="font-size: 14px"
                        class="font-weight-500 black60--text"
                    >
                        Deskripsi
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-card-text class="pa-0" style="margin-top: -10px">
                <app-editor
                    v-on:content-updated="data.description = $event"
                    :value="data.description"
                    :hasUpload="false"
                    :title="'Deskripsi'"
                ></app-editor>
            </v-card-text>
        </v-card>
        <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn color="darkFade" text @click="$emit('close')"> Tutup </v-btn>
            <v-btn
                color="blew"
                dark
                depressed
                :loading="isLoading"
                @click="upload()"
            >
                Simpan
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import AWS from "aws-sdk";
import MarkdownEditor from "@/modules/global/components/plugins/MarkdownEditor-c";
import { applyOssCredentials } from "@/modules/global/services/oss";
import ambis_test from "../services/ambis_test";

export default {
    name: "interpretation-form-dialog",
    components: {
        "app-editor": MarkdownEditor,
    },
    data: function () {
        return {
            isLoading: false,
            selectedPicture: null,
            data: {
                title: 1,
                description: "",
                icon: "",
                page: 1,
                is_main: true,
            },
            detail: {},
            url: null,
            addNew: false,
            keyimg: 0,
            imageFile: null,
            interpretasi_data: [
                "Linguistik",
                "Visual Spasial",
                "Logika Matematis",
                "Naturalistik",
                "Intrapersonal",
            ],

            list_potential: [],
        };
    },

    mounted() {
        this.getPotentialIntelligences();

        if (this.$attrs.detail.sub_interpretation_id) {
            this.getDetailInterpretation();
        }
    },

    methods: {
        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 200000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 200 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        async upload(e = 0) {
            this.isLoading = true;
            const fileImage = this.$refs.uploader.files[0];

            // if (this.imageFile && !this.data.image) {
            //   if (!fileImage) {
            //     this.$store.commit("showAlert", {
            //       message: `Gambar tema harus diisi!`,
            //       type: "error",
            //     });
            //     return;
            //   }
            // }

            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.data.icon && !file) {
                    this.save();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT;
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET,
                        Key:
                            "ambis_test/theme_" +
                            new Date().valueOf() +
                            "_" +
                            file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.data.icon = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        async save() {
            var context = this;
            const intrepretation_id = context.$attrs.detail.intrepretation_id;
            const subintrepretation_id =
                context.$attrs.detail.sub_interpretation_id;

            if (this.validateForm()) {
                context.isLoading = true;

                if (!subintrepretation_id) {
                    ambis_test.addSubInterpretation(
                        intrepretation_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                            }
                            context.isLoading = false;
                            context.$emit("save");
                        },
                    );
                } else {
                    ambis_test.editSubInterpretation(
                        subintrepretation_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                                context.isLoading = false;
                                context.$emit("save");
                            }
                        },
                    );
                }
            }
        },

        getDetailInterpretation() {
            this.data = {
                title: this.$attrs.detail.potential_id,
                description: this.$attrs.detail.description,
                icon: this.$attrs.detail.icon,
                page: this.$attrs.detail.page,
                is_main: this.$attrs.detail.is_main,
            };
            this.url = this.$attrs.detail.icon;

            // var context = this;
            // const sub_interpretation_id = context.$attrs.detail.sub_interpretation_id;

            // ambis_test.getDetailSubInterpretation(
            //   sub_interpretation_id,
            //   function (result) {
            //     if (result.success) {
            //       const data = result.data;

            //       context.data = {
            //         title: data.title,
            //         description: data.description,
            //         icon: data.icon,
            //         page: data.page,
            //         is_main: data.is_main,
            //       };

            //       context.url = data.icon;
            //     }
            //   }
            // );
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        validateForm() {
            var err = false;
            if (!this.url) {
                this.$store.commit("showAlert", {
                    message: `Gambar tema harus diisi`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.title) {
                this.$store.commit("showAlert", {
                    message: `Title wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.description) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        getPotentialIntelligences() {
            var context = this;

            ambis_test.getPotentialIntelligences(function (result) {
                if (result.success) {
                    context.list_potential = result.data;
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// DialogInterpretasi.vue?de1156cc